import StationInfo from './StationInfo';

export default StationInfo;


// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/components/stationInfo/index.js